import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { ConfirmModal } from '@components';
import { PageWrapper, TitleText, BasicText, BasicButton, ShortInput } from '@components';
import styles from './QuoteHome.module.css';
import { deleteQuote } from '@actions';
import { showErrorMessage, showSuccessMessage } from '@global';

const QuoteObject = ({
  quote,
  deleteQuote,
  onEdit
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const onDelete = () => {
    setLoading(true);
    deleteQuote({
      quote_id: quote.id
    }, () => {
      showSuccessMessage("Quote successfully deleted!");
      setShowDeleteModal(false);
      setLoading(false);
    }, () => {
      setLoading(false);
      showErrorMessage("Something went wrong");
    });
  };

  return (
      <div key= {quote.id} className={styles.quote_object_containewr}>
        <div style={{ flex: 1 }}>
          <div className={styles.quote_object_header}>
            <div style={{ display: "flex" }}>
              <div>Character count: {quote.quote.length}</div>
              <div className={styles.initial_quote}>
                {quote.is_initial &&
                  <div style={{
                    padding: 4,
                    paddingLeft: 8,
                    paddingRight: 8,
                    backgroundColor: "#48DFD1",
                    marginLeft: 12,
                    fontSize: 10
                  }}>
                    Initial Quote
                  </div>
                }
              </div>
            </div>
            <div>
              <BasicButton
                text="Edit"
                type="default"
                style={{ width: "70px" }}
                onClick={() => onEdit()}
              />
              <BasicButton
                style={{
                  marginTop: "10px",
                  width: "70px",
                  marginLeft: "12px",
                  color: "#ff3450",
                  borderWidth: 1,
                  borderColor: "#ff3450"
                }}
                text="Delete"
                onClick={() => setShowDeleteModal(true)}
              />
            </div>
          </div>
          {quote.quote}
          <div className={styles.author_style}>
            {quote.author}
          </div>
        </div>

        {showDeleteModal &&
          <ConfirmModal
            title={"Confirm Delete Quote"}
            visible={showDeleteModal}
            loading={loading}
            onCancel={() => setShowDeleteModal(false)}
            onSubmit={() => onDelete()}
          >
            <BasicText marginBottom="20px">
              Are you sure you want to delete this quote by {quote.author}?
            </BasicText>
          </ConfirmModal>
        }
      </div>
  );
};

export default connect(null, {
  deleteQuote
})(QuoteObject);
